import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=1267f59e&scoped=true"
import script from "./workList.vue?vue&type=script&lang=js"
export * from "./workList.vue?vue&type=script&lang=js"
import style0 from "./workList.vue?vue&type=style&index=0&id=1267f59e&scoped=true&lang=scss"
import style1 from "./workList.vue?vue&type=style&index=1&id=1267f59e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267f59e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1267f59e')) {
      api.createRecord('1267f59e', component.options)
    } else {
      api.reload('1267f59e', component.options)
    }
    module.hot.accept("./workList.vue?vue&type=template&id=1267f59e&scoped=true", function () {
      api.rerender('1267f59e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/components/workList.vue"
export default component.exports